import { render, staticRenderFns } from "./OrgRoles.vue?vue&type=template&id=19aec264&"
import script from "./OrgRoles.vue?vue&type=script&lang=js&"
export * from "./OrgRoles.vue?vue&type=script&lang=js&"
import style0 from "./OrgRoles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports